class CvCardSwatches extends HTMLElement {
  connectedCallback() {
    if (this.events || this.dataset.preview !== 'true') return;
    this.card = this.closest('.product-card-wrapper');
    if (!this.card) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.choices = [...this.querySelectorAll('[data-cv-choice]')];
    this.status = this.querySelector('[data-cv-status]');
    this.photo = this.card.querySelector('.card__media .media > img');
    this.price = this.card.querySelector('.card-information > .price');
    this.originalPrice = this.price?.cloneNode(true);
    this.originalPhoto = this.photo && Object.fromEntries(['src', 'srcset', 'sizes', 'alt'].map(key => [key, this.photo.getAttribute(key)]));
    this.links = [...this.card.querySelectorAll('.card__heading a')];
    this.choices.forEach(choice => {
      choice.setAttribute('role', 'button');
      choice.setAttribute('aria-pressed', 'false');
    });
    this.addEventListener('click', event => {
      const choice = event.target.closest('[data-cv-choice]');
      if (!choice || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.select(choice);
    }, options);
    this.addEventListener('keydown', event => {
      const choice = event.target.closest('[data-cv-choice]');
      if (choice && event.key === ' ') { event.preventDefault(); this.select(choice); }
    }, options);
    // A price/status update may move another swatch beneath a stationary
    // pointer. Only real pointer movement should change the hovered colour.
    this.addEventListener('pointermove', event => {
      const choice = event.target.closest('[data-cv-choice]');
      if (choice !== this.hoveredChoice && this.dataset.hover === 'true' && event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.hoveredChoice = choice;
        if (choice) this.select(choice);
      }
    }, options);
    this.addEventListener('pointerleave', () => { this.hoveredChoice = null; }, options);
  }

  select(choice) {
    if (!this.choices.includes(choice)) return;
    this.choices.forEach(item => item.setAttribute('aria-pressed', String(item === choice)));
    this.status.textContent = choice.dataset.label;
    this.links.forEach(link => link.setAttribute('href', choice.getAttribute('href')));
    this.card.querySelectorAll('modal-opener [data-product-url]').forEach(button => { button.dataset.productUrl = choice.getAttribute('href'); });
    if (this.photo) {
      if (choice.dataset.image) {
        this.photo.removeAttribute('srcset');
        this.photo.removeAttribute('sizes');
        this.photo.src = choice.dataset.image;
        this.photo.alt = choice.dataset.imageAlt;
        this.card.classList.add('cv-card-preview');
      } else {
        Object.entries(this.originalPhoto).forEach(([key, value]) => value === null ? this.photo.removeAttribute(key) : this.photo.setAttribute(key, value));
        this.card.classList.remove('cv-card-preview');
        this.status.textContent += ' — image unavailable';
      }
    }
    const nextPrice = choice.querySelector('[data-cv-price]')?.content.firstElementChild || this.originalPrice;
    if (this.price && nextPrice) { const copy = nextPrice.cloneNode(true); this.price.replaceWith(copy); this.price = copy; }
    // Existing product-level sale badges must not imply every colour is on sale.
    this.card.querySelectorAll('.card__badge .badge').forEach(badge => { badge.hidden = true; });
  }

  disconnectedCallback() { this.events?.abort(); this.events = null; }
}
if (!customElements.get('cv-card-swatches')) customElements.define('cv-card-swatches', CvCardSwatches);
